import { render, staticRenderFns } from "./qznnTable.vue?vue&type=template&id=7a023a14&scoped=true"
import script from "./qznnTable.vue?vue&type=script&lang=ts"
export * from "./qznnTable.vue?vue&type=script&lang=ts"
import style0 from "./qznnTable.vue?vue&type=style&index=0&id=7a023a14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a023a14",
  null
  
)

export default component.exports